import { useConsent } from "@/context/ConsentContext";
import { syncGoogleTagManagerConsent } from "@/utils/googleTagManager";
import { useEffect } from "react";

export function GoogleTagManagerLoader() {
  const { hydrated, analytics, marketing } = useConsent();

  useEffect(() => {
    if (!hydrated) return;
    syncGoogleTagManagerConsent({ analytics, marketing });
  }, [hydrated, analytics, marketing]);

  return null;
}
